<template>
  <b-navbar toggleable="lg" :class="'p-0'">
    <b-navbar-brand href="/" :class="'p-0'">
      <img :src="logoSrc" alt="Logo" class="d-block">
    </b-navbar-brand>
    <b-collapse id="nav-collapse" is-nav :class="'justify-content-end pr-lg-3'">
      <b-navbar-nav>
        <b-nav-item
            v-for="menuItem in menu"
            :key="menuItem.link"
            @click="scrollToScreen"
            :href="menuItem.link">
          {{ $t(menuItem.name) }}
        </b-nav-item>
        <b-nav-item class="nav-lng-btn">
          <LangBtn></LangBtn>
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>

    <div class="navbar-toggler justify-content-center ml-auto mr-lg-3 mr-sm-5">
    </div>
    <a href="#contacts" @click.prevent="$modal.show('contact-form')" class="standard-button transition d-none d-sm-block"
       onclick="ym(56244529, 'reachGoal', 'WRITE_1'); return true;">
      {{ $t(locale.menu.contactUsBtn) }}
    </a>
    <LangBtn class="head-lng-btn"></LangBtn>
    <b-navbar-toggle target="nav-collapse" :class="'navbar-toggler d-flex_ flex-column ml-4 d-lg-none_'">
      <span class="navbar-toggler-item d-block"></span>
      <span class="navbar-toggler-item d-block"></span>
      <span class="navbar-toggler-item d-block"></span>
    </b-navbar-toggle>
  </b-navbar>
</template>

<script>
import App from "@/App";
import $ from 'jquery'
import stringsKeys from "@/i18n/strings.json";
import LangBtn from "@/components/lang-button/LangBtn";

export default {
  name: "Navbar",
  components: {LangBtn},
  data: () => {
    return {
      logoSrc: App.data().globalSettings.logoSrc,
      locale: stringsKeys,
      menu: App.data().menu,
    }
  },
  methods: {
    scrollToScreen: function (ev) {
      ev.preventDefault();
      let screenId = ev.target.attributes.href.value;
      if($(screenId).offset()) {
        $([document.documentElement, document.body]).animate({
          scrollTop: $(screenId).offset().top
        }, 300);
      } else {
        this.$router.push('/' + screenId);
      }
    }
  },
}
</script>
<style lang="scss" scoped>
@import "src/scss/colors";

nav {
  .standard-button {
    min-width: 200px;
    height: 40px;
    font-size: 14px;
    line-height: 21px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
    margin: 0;
    @media (min-width: 768px) {
      border-width: 1px;
      border-radius: 2px;
    }
  }

  .nav-lng-btn {
    display: block;
    margin-left: -15px;
    @media (min-width: 644px) {
      display: none;
    }
  }

  .head-lng-btn {
    display: none;
    @media (min-width: 644px) {
      display: block;
    }
  }

  &.navbar {
    .navbar-nav {
      > * {
        margin-right: 3rem;

        &:last-child {
          margin-right: 0;
        }
      }

      .nav-link {
        font-family: 'Circe', sans-serif;
        font-weight: normal;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: $white;
      }
    }
  }
}

.navbar-expand-lg {
  .navbar-toggler {
    padding: 0.12rem .2rem;
    display: flex;
    @media (min-width: 1440px) {
      display: none;
    }

    .navbar-toggler-item {
      width: 100%;
      min-width: 18px;
      height: 2px;
      background-color: $white;

      & + .navbar-toggler-item {
        margin-top: 2px;
      }
    }
  }

  .navbar-collapse {
    display: none !important;
    @media (min-width: 1440px) {
      display: flex !important;
    }

    &.collapsing, &.show {
      display: flex !important;
      width: 100%;
      flex-direction: column;
      right: 0;
      background-color: #242423;
      position: absolute;
      top: 100%;
      z-index: 1;
      padding-top: 30px;

      ul {
        width: 100%;
        flex-direction: column;
        display: flex;
      }

      @media (min-width: 1440px) {
        position: relative;
        background-color: transparent;
        padding-top: 0;
      }
    }
  }
}

</style>

